export default {
  status: {
    open: 'Aperto',
    closed: 'Chiuso',
  },
  offline_until: 'Offline fino a',
  closed_until: 'Chiuso fino a',
  online_orders_paused: 'Ordini online in pausa',
  online_orders_paused_until: 'Ordini online in pausa fino a',
  reopens: 'Riapre',
  opens_today: 'Apre oggi',
  opens: 'Apre',
  open: 'Aperto',
  open_whole_day: 'Aperto tutto il giorno',
  outside_ordering_times: 'Fuori dagli orari di ordinazione',
};
